import React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import MapContainer from './containers/MapContainer';
import GPXUploadContainer from './containers/GPXUploadContainer';

import './App.scss';

const App = () => {
  return (
    <div className="App">
      <APIProvider apiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
        <div className="control-pannel">
          <GPXUploadContainer />
        </div>
        <MapContainer />
      </APIProvider>
    </div>
  );
};

export default App;
